module.exports = __webpack_public_path__ + "static/media/19ESCAP46.46a00d45.jpg";